import * as z from "zod"

export const addressDetailsSchema = z.object({
  formatted_address: z.string().optional().nullable(),
  place_id: z.string().optional().nullable(),
  lat: z.number().optional().nullable(),
  lng: z.number().optional().nullable(),
})
